/**
 * TanStack Query hooks for `fraud-analyst-workbench-case-review-queue`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fraudAnalystWorkbenchCaseReviewQueueQueryKeys,
	type CreateFraudAnalystWorkbenchCaseReviewQueueBody,
	type ListFraudAnalystWorkbenchCaseReviewQueueResponse,
	type FraudAnalystWorkbenchCaseReviewQueueRow,
} from "./api";

export function useFraudAnalystWorkbenchCaseReviewQueueList(): UseQueryResult<ListFraudAnalystWorkbenchCaseReviewQueueResponse, Error> {
	return useQuery({
		queryKey: fraudAnalystWorkbenchCaseReviewQueueQueryKeys.list(),
		queryFn: list,
	});
}

export function useFraudAnalystWorkbenchCaseReviewQueueCreate(): UseMutationResult<FraudAnalystWorkbenchCaseReviewQueueRow, Error, CreateFraudAnalystWorkbenchCaseReviewQueueBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudAnalystWorkbenchCaseReviewQueueQueryKeys.all });
		},
	});
}

export function useFraudAnalystWorkbenchCaseReviewQueueDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudAnalystWorkbenchCaseReviewQueueQueryKeys.all });
		},
	});
}
